import axios from '@/utils/axios';

export default {
  getEngine() {
    return axios.get(`/engines`,);
  },
  getEngineList() {
    return axios.get(`/engines/list`);
  },
  getMenu() {
    return axios.get(`/menu/list`);
  },
};
